export const setDeskIdZendesk = ({
  i,
  intent,
  use_custom_fields,
  integrations,
  getCustomFields,
  updateIntent,
}) => {
  const integration_zendesk_full = integrations?.find(
    (int) => int.channel === "zendesk_full"
  );
  const use_custom = integration_zendesk_full?.multiple?.filter(
    (int) => int.use_custom_fields
  );

  if (use_custom?.length === 1) {
    const new_desk_id = use_custom[0].id;

    if (intent.parameters && intent.parameters[i]) {
      if (!intent.parameters[i].zendesk_ticket_field) {
        intent.parameters[i].zendesk_ticket_field = {};
      }

      if (!intent.parameters[i].zendesk_ticket_field.desk_id) {
        intent.parameters[i].zendesk_ticket_field.desk_id = new_desk_id;
      }

      updateIntent(intent);
    }

    if (!use_custom_fields || !use_custom_fields[new_desk_id]) {
      getCustomFields("zendesk", new_desk_id, intent);
    }
  }
};
